import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'sigecom-error',
  template: `
    <small
      class="text-xs font-normal ml-2"
      [ngClass]="{
        'text-sigecom-danger': error,
        'text-sigecom-danger/50': disabled,
      }"
    >
      {{ error }}
    </small>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  @Input() error: string | null = null;
  @Input() disabled: boolean = false;
}
